export default class DafSpotify {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        $('.daf-spotify__tab').on('click', function (e){
            e.preventDefault();
            let index = $(this).index() + 1;
            $(this).parents('.daf-spotify__tabs').find('div').removeClass('active');
            $(this).addClass('active');
            $(this).parents('.daf-spotify').find('.daf-spotify__current span').html($(this).text());
            $(this).parents('.daf-spotify').find('.daf-spotify__item').removeClass('active');
            $(this).parents('.daf-spotify').find('.daf-spotify__item:nth-child('+index+')').addClass('active');
            $(this).parents('.daf-spotify__tabs').removeClass('open');
        })

        $('.daf-spotify__current').on('click', function (e) {
            let list = $(this).parents('.daf-spotify').find('.daf-spotify__tabs');
            list.hasClass('open') ? list.removeClass('open') : list.addClass('open');
        });

    }
}